<template>
  <div class="page">
    <!-- 头部 -->
    <Header></Header>
    <!-- 产品详情 -->
    <div class="content">
      <div class="title">项目介绍：</div>
      <p>{{ productDetail.content }}</p>
      <div class="content_img_list">
        <div class="title">项目截图：</div>
        <div class="item">
          <img :src="item" @click="showFn" alt="" v-for="(item, index) in productDetail.imageInput" :key="index">
        </div>
        <div class="mobile_item" v-if="productDetail.mobileImageInputs">
          <img :src="item" alt="" @click="showMobile" v-for="(item, index) in productDetail.mobileImageInput" :key="index">
        </div>
      </div>
    </div>
    <!-- <nut-imagepreview :show="showPreview" :images="dataImgItem" @close="showFn" />
    <nut-imagepreview :show="showPreviewMobile" :images="mobileImages" @close="showMobile" /> -->
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "@/components/page/Footer.vue";
import Header from "@/components/page/Header.vue";
import { getProductDetail } from "@/api/app.js";
export default {
  components: {
    Footer,
    Header
  },
  data() {
    return {
      id: null,
      productDetail: {},
      showPreview: false,
      showPreviewMobile: false,
      dataImgItem: [],
      mobileImages: [],
    }
  },
  created() {
    this.id = this.$route.query && this.$route.query.id;
    this.getProductDetail();
  },
  methods: {
    showMobile() {
      this.showPreviewMobile = !this.showPreviewMobile
    },
    showFn() {
      this.showPreview = !this.showPreview
    },
    getProductDetail() {
      getProductDetail({id: this.id}).then(res => {
        this.productDetail = res;
        for(let i in res.imageInput) {
          this.dataImgItem.push({imgSrc: res.imageInput[i]});
        }
        for (let i in res.mobileImageInput) {
          this.mobileImages.push({imgSrc: res.mobileImageInput[i]});
        }
        
      })
    },
  },
}
</script>
<style scoped>
.page .content /deep/ .nut-swiper-item {
  height: 300px !important;
}

.page .content {
  margin-top: 150px;
  padding: 0 32px;
  box-sizing: border-box;
}
.page .content p {
  color: #666666;
  line-height: 40px;
  font-size: 24px;
  margin-bottom: 60px;
  text-align: justify;
  white-space:pre-line;
}
.title {
  color: #222;
  font-size: 24px;
  font-weight: 550;
  margin-bottom: 40px;
}
.page .content .content_img_list .item {
  width: 100%;
  margin-top: 20px;
  /* display: flex;
  justify-content: space-between;
  flex-wrap: wrap; */
}
.page .content .content_img_list .item img {
  display: block;
  width: 100%;
  /* height: 315px; */
  margin-bottom: 40px;
}

.page .content .content_img_list .mobile_item {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.page .content .content_img_list .mobile_item img {
  display: block;
  width: 47%;
  height: 720px;
  margin-bottom: 40px;
}

</style>